import Fuse from 'fuse.js'

const THRESHOLD = 0.3

// tslint:disable-next-line:no-any
export const Search = (searchTerm: string, array: any[], keys: string[]) => {
  const fuse = new Fuse(array, {
    threshold: THRESHOLD,
    keys: keys
  })

  return fuse.search(searchTerm)
}

export const SortType = {
  Asc: 'asc',
  Desc: 'desc'
}

export type SortType = string



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/FuzzySearch.ts